/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const ERRORS = {
  badRequest: {
    code: 400,
    name: 'Bad Request',
  },
  internalServerError: {
    code: 500,
    name: 'Internal Server Error',
  },
  notFound: {
    code: 404,
    name: 'Not Found',
  },
  notImplemented: {
    code: 501,
    name: 'Not Implemented',
  },
  unprocessableContent: {
    code: 422,
    name: 'Unprocessable Content',
  },
};

export const ERROR_MESSAGES = {
  paginationEncodeFailed: 'Unable to encode pagination token',
  paginationInvalidToken: 'Invalid pagination token',
  paginationOnlyOneDirection: 'Must specify only one of the following: page[after] or page[before]',
  primaryKeyInvalidPK: 'Invalid partition key',
};
